import { status } from '../../helpers'

const getRecipientStoreDefaultState = () => {
  return {
    loadRecipients: status.INITIALIZED,
    loadRecipient: status.INITIALIZED,
    creatingRecipient: false,
    newRecipient: {
      name: '',
      email: '',
      address_one: '',
      address_two: '',
      phone: '',
      city: '',
      country: '',
      state: '',
      zipcode: '',
      salesforce_resource_uid: null
    },
    recipients: [],
    recipient: {},
    errors: {},
    loadRecipientList: status.INITIALIZED,
    recipientList: {},
    recipientErrors: [],
    recipientListRecords: [],
    recipientListEcommerceRecords: [],
    recipientListDetails: [],
    recipientType: '',
    // errors: []
    selectedRecipientList: [],
    selectedEcommerceRecipientList: [],
    recipientTotal: 0,
    orderRecipientList: {}
  }
}

export default getRecipientStoreDefaultState
